import { render, staticRenderFns } from "./TariffEntitiesGrid.vue?vue&type=template&id=5f7f6c58"
import script from "./TariffEntitiesGrid.vue?vue&type=script&lang=js"
export * from "./TariffEntitiesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports